<template>
  <div v-if="params.data">
    <div v-if="params.data.quotes > 0">
      <router-link
        :to="url"
        @click.stop.prevent
        class="text-inherit hover:text-primary"
      >
        <div class="flex items-center  hover:text-primary" :style="{'direction': $vs.rtl ? 'rtl' : 'ltr'}" v-if="params.data">
          {{ params.value }}
        </div>
      </router-link>
    </div>
    <div v-else>
      <div class="flex items-center  hover:text-primary" :style="{'direction': $vs.rtl ? 'rtl' : 'ltr'}">
        0
      </div>
    </div>
  </div>

</template>

<script>
export default {
  name: 'CellRendererLinkQuote',
  computed: {
    url () {
      //return '/apps/user/user-view/268'

      // Below line will be for actual product
      // Currently it's commented due to demo purpose - Above url is for demo purpose
      return `/associate/users/vendor/view/${  this.params.data ? this.params.data.id : 0}?tab=quote`
    }
  }
}
</script>
